import React, { FunctionComponent } from 'react';
import { Modal as SemanticModal, ModalProps } from 'semantic-ui-react';

import { useModal } from './modalContext';

const Modal: FunctionComponent<ModalProps> = (props) => {
  const { modalContent, handleModal, modal, size } = useModal();

  return (
    <SemanticModal
      {...props}
      onClose={() => handleModal()}
      open={modal}
      size={size}
    >
      {modalContent}
    </SemanticModal>
  );
};

export default Modal;
